export default "https://legacy.eskolare-development.com/images/social-call-to-action.png";